import { Box, BoxProps } from '@mui/material'
import React, { ReactNode, useEffect, useRef, useState } from 'react'

interface BoxWrapperProps extends BoxProps {
    children: ReactNode;
    type: "request" | "response";
}

const BaloonShaped: React.FC<BoxWrapperProps> = ({
    children,
    type
}) => {
    const edgeSize = 30;
    const isForRequest = (type === "request");
    const ref = useRef(null);
    const [dimesions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            if (ref.current) {
                const { clientWidth, clientHeight } = ref.current;
                setDimensions({
                    width: clientWidth,
                    height: clientHeight,
                });
            }
        };

        const resizeObserver = new ResizeObserver(handleResize);
        const currentRef = ref.current;
        if (currentRef) {
            resizeObserver.observe(currentRef);
            handleResize();
        }

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            if (currentRef)
                resizeObserver.unobserve(currentRef);
            resizeObserver.disconnect();
        };
    }, []);

    return <Box
        ref={ref}
        sx={{
            clipPath: isForRequest ?
                `path('M 0 0 H ${dimesions.width - 25} V ${dimesions.height - 30} L ${dimesions.width - 10} ${dimesions.height - 10} A 7 7 0 0 1 ${dimesions.width-15} ${dimesions.height}  H ${edgeSize} L 0 ${dimesions.height - edgeSize} V 0 Z')`
                : `path('M 25 0 H ${dimesions.width - edgeSize} L ${dimesions.width} ${edgeSize} V ${dimesions.height} H 15 A 7 7 0 0 1 10 ${dimesions.height - 10} L 25 ${dimesions.height - 30} V 0')`
        }}>
        {children}
    </Box>
};

export default BaloonShaped;